import ConsoleLayout from "@/components/ConsoleLayout";
import AgentCard from "@/components/AgentCard";
import { useLanguage } from "@/contexts/LanguageContext";
import { mockScienceAgents } from "@/data/mockScienceAgents";

export default function ScienceAgentMarketplace() {
  const { t, language } = useLanguage();

  return (
    <ConsoleLayout
      title={t("sciAgents.title")}
      actions={undefined}
    >
      <div className="p-6">
        {/* Header */}
        <div className="mb-4">
          <div className="flex items-center gap-3 mb-1">
            <h2 className="text-lg font-bold text-white" style={{ fontFamily: "Space Grotesk, sans-serif" }}>
              {t("sciAgents.title")}
            </h2>
            <span className="text-[10px] px-2 py-0.5 rounded-full bg-white/5 text-slate-400 border border-white/8">
              {mockScienceAgents.length} {language === "zh" ? "个模型" : "models"}
            </span>
          </div>
          <p className="text-xs text-slate-500">
            {language === "zh"
              ? "深入理解各行业实际业务的领域 LLM 模型，集成领域专业工具集与数据源，为不同科学垂直领域交付专业分析结果。"
              : "Domain-specific LLM models with deep understanding of industry workflows, integrating specialized tools and data sources to deliver professional analysis for each scientific vertical."}
          </p>
        </div>

        {/* Model cards grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3">
          {mockScienceAgents.map((agent) => (
            <AgentCard key={agent.id} agent={agent} />
          ))}
        </div>
      </div>
    </ConsoleLayout>
  );
}
